import { alpha } from '@mui/material/styles';

import styled from '../../../../styled';
import { colorsPalette, SMALL_RADIUS_PX } from '../../../../theme';

const CardGradient = styled('div')`
  position: relative;
  z-index: 1;
  width: 100%;
  height: 66px;
  bottom: 0;
  left: 0;
  border-radius: 0 0 ${SMALL_RADIUS_PX} ${SMALL_RADIUS_PX};
  background: linear-gradient(
    0deg,
    ${colorsPalette.blackSecondary} 0%,
    ${alpha(colorsPalette.blackSecondary, 0.9)} 28.85%,
    ${alpha(colorsPalette.blackSecondary, 0.0)} 100%
  );
`;

export default CardGradient;
